import React, { useState, useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { getShowBySlug } from '../../../../services/showService';

const SHOW_SLUG = 'puntodefe';
const FILES_BASE = 'https://files.tnonetwork.com';
const COVER_URL = `${FILES_BASE}/shows/cover/${SHOW_SLUG}.jpg`;
const DEFAULT_DESCRIPTION = 'El espacio donde Bancaribe será patrocinante del bloque "Consejos para el Progreso". Margarita Toledo posiciona a Bancaribe como el aliado del crecimiento personal y la banca con valores. Transmisión por TNO Network.';

const PuntoDeFeSection = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up('sm'), { defaultMatches: true });
  const [synopsis, setSynopsis] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getShowBySlug(SHOW_SLUG).then((show) => {
      if (!cancelled && show && show.synopsis) setSynopsis(show.synopsis);
    });
    return () => { cancelled = true; };
  }, []);

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Programa ancla
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Punto de Fe con Margarita Toledo
        </Box>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/puntodefe"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/puntodefe
          </Link>
        </Typography>
        <Typography variant="body1" color="textSecondary" align="center" sx={{ maxWidth: 640, mx: 'auto' }}>
          {synopsis || DEFAULT_DESCRIPTION}
        </Typography>
      </Box>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              position: 'relative',
              paddingBottom: '56.25%',
              height: 0,
              overflow: 'hidden',
              borderRadius: isSm ? 4 : 0,
              boxShadow: 3,
            }}
          >
            <Box
              component="iframe"
              src="https://www.youtube-nocookie.com/embed/0y1kYrSkGBA"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 0,
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
              title="Punto de Fe | TNO Network"
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            maxWidth={400}
            margin="0 auto"
            sx={{
              p: 2,
              borderRadius: 2,
              position: 'relative',
              overflow: 'hidden',
              backgroundImage: `url(${COVER_URL})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundColor: 'rgba(0, 0, 0, 0.35)',
              backgroundBlendMode: 'multiply',
            }}
          >
            <Box
              sx={{
                minHeight: 220,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 2,
                bgcolor: 'transparent',
                overflow: 'hidden',
              }}
            >
              <Box
                component="img"
                src={`${FILES_BASE}/shows/logo/${SHOW_SLUG}.png`}
                alt="Logo Punto de Fe"
                sx={{
                  maxWidth: '70%',
                  height: 'auto',
                  objectFit: 'contain',
                }}
              />
            </Box>
            <Box
              mt={3}
              textAlign="center"
              sx={{
                width: '100%',
                px: 2,
                py: 2.5,
                borderRadius: 2,
                backgroundColor: 'rgba(0, 0, 0, 0.20)',
              }}
            >
              <Box
                component="img"
                src="/images/Margarita Toledo Punto de Fe-Programa..png"
                alt="Margarita Toledo - Punto de Fe"
                sx={{
                  width: 120,
                  height: 120,
                  borderRadius: '50%',
                  objectFit: 'cover',
                  boxShadow: 2,
                }}
              />
              <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 1, color: 'common.white' }}>
                Margarita Toledo
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.92)' }}>
                Ancla de Punto de Fe
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PuntoDeFeSection;
